module.exports = __webpack_public_path__ + "static/media/video.a71b0087.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/elements/video.svg
// module id = 983
// module chunks = 1